import { Modal, Stack } from '@mantine/core';
import { styled } from '@linaria/react';
import type { Goal, Outcome } from '../../../api/strategy-client/strategy-client.type';
import type { Initiative } from '../../../api/initiative-client/initiative-client.type';
import { Text } from '../../../ui-library/typography/typography';

type Props = {
  entity: Initiative | Outcome | Goal | null;
  opened: boolean;
  onClose: () => void;
};

export const StrategyPerformanceInfoModal = ({ entity, opened, onClose }: Props) => {
  if (!entity) {
    return null;
  }

  return (
    <StyledModal size={580} opened={opened} onClose={onClose} title={entity.name} centered>
      <Stack gap="md">
        <div>
          <Text size="small" weight="medium" style={{ marginBottom: 8 }}>
            Description
          </Text>
          <Text size="small">{entity.description || 'No description provided'}</Text>
        </div>
        {entity.key && (
          <div>
            <Text size="small" weight="medium" style={{ marginBottom: 8 }}>
              Key
            </Text>
            <Text size="small">{entity.key}</Text>
          </div>
        )}
        {entity.start_date && (
          <div>
            <Text size="small" weight="medium" style={{ marginBottom: 8 }}>
              Start Date
            </Text>
            <Text size="small">{new Date(entity.start_date).toLocaleDateString()}</Text>
          </div>
        )}
        {entity.end_date && (
          <div>
            <Text size="small" weight="medium" style={{ marginBottom: 8 }}>
              End Date
            </Text>
            <Text size="small">{new Date(entity.end_date).toLocaleDateString()}</Text>
          </div>
        )}
      </Stack>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .mantine-Modal-content {
    box-sizing: border-box;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-radius: 8px;
    min-width: 580px;
  }

  .mantine-Modal-header {
    padding: 0;
    min-height: 36px;
  }

  .mantine-Modal-close {
    position: absolute;
    right: 0px;
    top: 0px;
    color: var(--sky-dark);
    background-color: transparent;
  }

  .mantine-Modal-body {
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;
